import { Crown, Users, User as UserIcon } from "lucide-react";

/**
 * Generates a secure password with mixed character types
 * @param length - Length of the password (default: 12)
 * @returns Generated secure password
 */
export const generateSecurePassword = (length: number = 12): string => {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
  let password = "";
  
  // Ensure at least one character from each category
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const special = "!@#$%^&*";
  
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += special[Math.floor(Math.random() * special.length)];
  
  // Fill the rest randomly
  for (let i = password.length; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)];
  }
  
  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
};

/**
 * Gets the appropriate color classes for a user role badge
 * @param role - User role string
 * @returns Tailwind CSS classes for the role badge
 */
export const getRoleColor = (role: string): string => {
  switch (role) {
    case 'super_admin': return 'bg-red-100 text-red-800';
    case 'recruiter': return 'bg-blue-100 text-blue-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

/**
 * Gets the appropriate icon component for a user role
 * @param role - User role string
 * @returns Lucide icon component
 */
export const getRoleIcon = (role: string) => {
  switch (role) {
    case 'super_admin': return Crown;
    case 'recruiter': return Users;
    default: return UserIcon;
  }
};

/**
 * Generates user initials from first and last name
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @returns Uppercase initials (e.g., "JD")
 */
export const getInitials = (firstName: string, lastName: string): string => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};
